import { defineResolver } from 'customer-flows/utils/quote/resolvers'

export default {
  activityId: defineResolver<string | undefined>(({ resolveStoreProp }) => ({
    resolve: () => {
      return resolveStoreProp('activity', 'id')
    }
  }))
}
